
export const getCurrencyEntries = (labels, currency) => {
    let entries = [];
    Object.entries(labels).forEach((item) => {
        let entry = {};
        entry.label = item[1];
        entry.key = item[0];
        entry.value = item[1];
        entry.disabled = false;
        entry.selected = item[1] === currency;
        entries.push(entry);
    });
    return entries;
};
